<template>
  <div
    class="reply_box ticket_mail_reply_textarea"
    :class="{ show: showReplyBox }"
  >
    <div class="ticket_mail_reply_textarea_top_bar_wrap">
      <div class="ticket_mail_reply_textarea_top_bar">
        <div class="author info_bg">
          <span>{{ userFirstLetter() }}</span>
        </div>
        <select
          class="form_global height_30p width_150p mr_10"
          v-model="form.email_type"
        >
          <option value="reply">Reply</option>
          <option value="note">Add Note</option>
          <option value="forward">Forward</option>
        </select>
        <v-errors :errors="errorFor('email_type')"></v-errors>

        <div class="content_details" v-if="form.email_type != 'note'">
          <p>From: <b>Support</b> (support@vlan24.com)</p>
        </div>
        <select
          v-if="form.email_type == 'note'"
          class="form_global height_30p width_150p mr_10"
          v-model="form.note_mode"
        >
          <option value="private">Private</option>
          <option value="public">Public</option>
        </select>
      </div>
      <template
        v-if="form.email_type == 'reply' || form.email_type == 'forward'"
      >
        <div class="mail_to_response d_flex_btwn">
          <p v-if="form.email_type == 'reply'">
            <b class="fw_500">To : </b>
            <span class="mr_10">
              <b>{{ ticket.customer_email }}</b>
            </span>
          </p>
          <div
            class="d_flex_start width_full"
            v-if="form.email_type == 'forward'"
          >
            <b class="fw_500 pr_15">To:</b>
            <span
              class="d_flex_start width_full"
              :class="{ custom_has_error: errorFor('forward_to_emails') }"
            >
              <Multiselect
                v-model="selectedTos"
                :options="users"
                :multiple="true"
                :showLabels="false"
                :close-on-select="true"
                placeholder="Select to"
                label="email"
                track-by="email"
                @Select="onToSelect"
                @remove="onToRemove"
                :taggable="true"
                @tag="addToCustomMail"
              />
            </span>
          </div>
          <p class="width_100p ml_10">
            <span class="color_green" v-if="!showCc" @click="showCc = true"
              >Cc | </span
            ><span class="color_green" v-if="!showBcc" @click="showBcc = true"
              >Bcc</span
            >
          </p>
        </div>

        <div class="mail_to_cc" v-if="showCc">
          <div class="d_flex_start width_full">
            <b class="fw_500 pr_15">Cc:</b>
            <span
              class="d_flex_start width_full"
              :class="{ custom_has_error: errorFor('cc_emails') }"
            >
              <Multiselect
                v-model="selectedCcs"
                :options="users"
                :multiple="true"
                :showLabels="false"
                :close-on-select="true"
                placeholder="Select cc"
                label="email"
                track-by="email"
                :optionHeight="20"
                @Select="onCcSelect"
                @remove="onCcRemove"
                :taggable="true"
                @tag="addCcCustomMail"
              />
            </span>
            <span class="d_flex_start pl_15 clear_color" @click="clearCcs"
              >Clear</span
            >
          </div>
        </div>
        <div class="mail_to_cc" v-if="showBcc">
          <div class="d_flex_start width_full">
            <b class="fw_500 pr_15">Bcc:</b>
            <span
              class="d_flex_start width_full"
              :class="{ custom_has_error: errorFor('bcc_emails') }"
            >
              <Multiselect
                v-model="selectedBccs"
                :options="users"
                :multiple="true"
                :showLabels="false"
                :close-on-select="true"
                placeholder="Select bcc"
                label="email"
                track-by="email"
                :optionHeight="20"
                @Select="onBccSelect"
                @remove="onBccRemove"
                :taggable="true"
                @tag="addBccCustomMail"
              />
            </span>
            <span class="d_flex_start pl_15 clear_color" @click="clearBccs"
              >Clear</span
            >
          </div>
        </div>
      </template>
      <template v-if="form.email_type == 'note'">
        <div class="mail_to_cc">
          <div class="d_flex_start width_full">
            <b class="fw_500 width_150p pr_15">Notify to:</b>
            <span
              class="d_flex_start width_full"
              :class="{ custom_has_error: errorFor('notify_emails') }"
            >
              <Multiselect
                v-model="selectedUsers"
                :options="users"
                :multiple="true"
                :showLabels="false"
                :close-on-select="true"
                placeholder="Select user"
                label="email"
                track-by="email"
                :optionHeight="20"
                @Select="onUserSelect"
                @remove="onUserRemove"
                :taggable="true"
                @tag="addNoteCustomMail"
              />
            </span>
          </div>
        </div>
      </template>
    </div>
    <div :class="['form_row', { has_error: errorFor('description') }]">
      <div class="form_inline">
        <text-editor
          v-model:text="form['description']"
          :id="'description'"
        ></text-editor>
        <v-errors :errors="errorFor('description')"></v-errors>
      </div>
    </div>
    <div class="attachment_preview_show product_list_wrap">
      <div class="product_list">
        <draggable
          :list="form.attachments"
          item-key="image"
          tag="ul"
          ghost-class="ghost"
          @end="imageSorted"
        >
          <template #item="{ element, index }">
            <li>
              <div class="inner">
                <div class="img">
                  <template
                    v-if="
                      ['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(
                        element.file_extension
                      )
                    "
                  >
                    <div class="cross_ic" @click="removeImage(element, index)">
                      <i class="fas fa-times"></i>
                    </div>
                    <img :src="element.file_path" />
                  </template>
                  <template v-if="['pdf'].includes(element.file_extension)">
                    <div class="cross_ic" @click="removeImage(element, index)">
                      <i class="fas fa-times"></i>
                    </div>
                    <embed :src="element.file_path" />
                  </template>
                  <template
                    v-if="
                      [
                        'xls',
                        'xlsx',
                        'xlm',
                        'xla',
                        'xlc',
                        'xlt',
                        'xlw',
                        'csv',
                      ].includes(element.file_extension)
                    "
                  >
                    <div class="cross_ic" @click="removeImage(element, index)">
                      <i class="fas fa-times"></i>
                    </div>
                    <i class="fas fa-file-excel fa-10x"></i>
                  </template>
                  <template v-if="['docx'].includes(element.file_extension)">
                    <div class="cross_ic" @click="removeImage(element, index)">
                      <i class="fas fa-times"></i>
                    </div>
                    <i class="fas fa-file-word fa-10x"></i>
                  </template>
                  <template v-if="['zip'].includes(element.file_extension)">
                    <div class="cross_ic" @click="removeImage(element, index)">
                      <i class="fas fa-times"></i>
                    </div>
                    <i class="fas fa-file-archive fa-10x"></i>
                  </template>
                  <!-- <template v-if="allErrors && allErrors['attachments.'+index]">
                                        pgh
                                        <small v-for="(error, errorIndex) in allErrors['attachments.'+index]" :key="'error_' + index + '_attachments_'+errorIndex">{{error}}</small>
                                    </template> -->
                </div>
                <div class="preview_text">
                  <span>{{ element.original_file_name }}</span>
                </div>
              </div>
            </li>
          </template>
        </draggable>
      </div>
    </div>
    <div class="d_flex_btwn mt_15 mb_15">
      <div class="d_flex_start">
        <button
          type="button"
          class="btn btn_black has_border_radius width_100p"
          @click.prevent="submitReply"
        >
          Send
        </button>
        <div class="dropzone-previews"></div>
        <div class="mail_content_details_list dropzone-container">
          <ul class="pb_0 pl_15">
            <li class="dropzone-clickable">
              <div class="attach_btn">
                <i class="lni lni-paperclip font_18p cursor_pointer"></i>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="d_flex_end">
        <div class="mail_content_details_list">
          <ul class="pb_0 pl_15">
            <li class="del_mail_form" @click.prevent="closeReplyBox">
              <span class="font_18p"
                ><i class="lni lni-trash-can cursor_pointer"></i
              ></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import TextEditor from '@/components/shared/TextEditor';
import Dropzone from 'dropzone';
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';
export default {
  name: 'reply-box-component',
  components: { Multiselect, TextEditor, draggable },
  data() {
    return {
      form: {
        forward_to_emails: [],
        notify_emails: [],
        cc_emails: [],
        bcc_emails: [],
        email_type: this.replyBoxType,
        note_mode: 'private',
        description: '',
        attachments: [],
      },
      contacts: [],
      users: [],
      selectedTos: [],
      selectedCcs: [],
      selectedBccs: [],
      showCc: true,
      showBcc: false,
      selectedUsers: [],
      dropzoneInstance: null,
    };
  },
  props: {
    showReplyBox: {
      type: Boolean,
      default: false,
    },
    replyBoxType: {
      type: String,
    },
    ticket: {
      type: Object,
      required: true,
    },
    forwardedMessage: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  watch: {
    replyBoxType(newVal) {
      if (newVal === 'note') {
        this.form.note_mode = 'private';
      } else {
        this.form.note_mode = '';
      }
    },
    'form.email_type'(newVal) {
      if (newVal === 'note') {
        this.form.note_mode = 'private';
      } else {
        this.form.note_mode = '';
      }
    },
    forwardedMessage: {
      handler(newVal) {
        this.form.description = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getContacts();
    this.getUsers();
  },
  mounted() {
    if (this.ticket && this.ticket.emails.length > 0) {
      this.showCc = true;
    }

    if (!this.dropzoneInstance) {
      this.initDropzone();
    }

    this.form.cc_emails.push('info@vlan24.com');
    this.selectedCcs.push({ email: 'info@vlan24.com' });
  },
  beforeUnmount() {
    this.destroyDropzone();
  },
  methods: {
    userFirstLetter() {
      if (this.user?.name) {
        return this.user?.name.slice(0, 1);
      }
    },
    destroyDropzone() {
      if (this.dropzoneInstance) {
        this.dropzoneInstance.destroy();
        this.dropzoneInstance = null;
      }
    },
    initDropzone() {
      if (this.dropzoneInstance) {
        this.dropzoneInstance.destroy();
        this.dropzoneInstance = null;
      }

      let that = this;
      const user = JSON.parse(localStorage.getItem('admin')) || null;
      // for image.
      that.$nextTick(() => {
        that.dropzoneInstance = new Dropzone('.dropzone-container', {
          clickable: '.dropzone-clickable',
          disablePreviews: true, // will not show preview
          createImageThumbnails: true,
          addRemoveLinks: true,
          // previewsContainer: '.dropzone-previews',
          maxFiles: 2000,
          autoDiscover: false,
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          url: `${process.env.VUE_APP_API_BASE_URL}/temporary-image-upload`,
          success: function (file, response) {
            let image = {
              id: '',
              sort: that.form.attachments.length + 1,
              draft: response.draft,
              file_extension: response.file_extension,
              file_path: response.file_path,
              original_file_name: response.original_file_name,
              original_size: response.original_size,
            };
            that.form.attachments.push(image);
            // since no preview there is nothing to remove
            // this.removeFile(file); // This line removes the preview
          },
          error: function (file, response) {
            let errors = that.errors ? that.errors : {};
            errors.attachments =
              errors && errors.attachments ? errors.attachments : [];
            errors.attachments = response.errors.file;
            that.errors = errors;
            // this.removeFile(file);
          },
          removedfile: function () {
            let errors = that.errors ? that.errors : {};
            errors.attachments = null;
            that.errors = errors;
            // since no preview there is nothing to remove
            // file.previewElement.remove();
          },
        });
      });
    },
    getContacts() {
      this.axios.get('/active-contacts-for-relation').then(({ data }) => {
        this.contacts = data.data;
      });
    },
    getUsers() {
      this.axios.get('/active-users-for-relation').then(({ data }) => {
        this.users = data.data;
      });
    },
    onCcSelect(selected) {
      console.log(selected, 'sss');
      this.form.cc_emails.push(selected.email);
    },
    onCcRemove(selected) {
      this.form.cc_emails = this.form.cc_emails.filter(
        (cc) => cc !== selected.email
      );
    },
    onBccSelect(selected) {
      this.form.bcc_emails.push(selected.email);
    },
    onBccRemove(selected) {
      this.form.bcc_emails = this.form.bcc_emails.filter(
        (bcc) => bcc !== selected.email
      );
    },
    clearCcs() {
      this.selectedCcs = [];
      this.form.cc_emails = [];
      this.showCc = false;
    },
    clearBccs() {
      this.selectedBccs = [];
      this.form.bcc_emails = [];
      this.showBcc = false;
    },
    onUserSelect(selected) {
      this.form.notify_emails.push(selected.email);
    },
    onUserRemove(selected) {
      this.form.notify_emails = this.form.notify_emails.filter(
        (user) => user !== selected.email
      );
    },
    onToSelect(selected) {
      this.form.forward_to_emails.push(selected.email);
    },
    onToRemove(selected) {
      this.form.forward_to_emails = this.form.forward_to_emails.filter(
        (user) => user !== selected.email
      );
    },
    removeImage(element, index) {
      if (!this.form) return;
      if (!this.form.attachments) return;
      if (!element.id) {
        let formData = new FormData();
        formData.append('draft', element.draft);
        this.axios.post('/temporary-image-remove', formData).then(() => {});
      }
      this.form.attachments.splice(index, 1);
      this.imageSorted();
    },
    imageSorted() {
      let sort = 1;
      for (let index = 0; index < this.form.attachments.length; index++) {
        this.form.attachments[index].sort = sort++;
      }
    },
    submitReply() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();
      this.form.ticket_id = this.ticket.id;
      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      formData.append('attachments', JSON.stringify(this.form.attachments));
      formData.append('user', JSON.stringify(this.user));

      this.axios
        .post('/email-reply', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('Submitted Successfully!');
          this.$emit('closeReplyBox', 'success');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.form = {
        forward_to_emails: [],
        notify_emails: [],
        cc_emails: [],
        bcc_emails: [],
        email_type: this.replyBoxType,
        note_mode: 'private',
        description: '',
        attachments: [],
      };
    },
    closeReplyBox() {
      this.$swal({
        title: 'Are you sure want to leave?',
        text: 'You have unsaved changes and your data will be lost. Are you sure you want to leave?',
        showCancelButton: true,
        confirmButtonText: 'Leave without saving.',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit('closeReplyBox');
        }
      });
    },
    addToCustomMail(newEmail) {
      if (this.validateEmail(newEmail)) {
        const tag = {
          email: newEmail,
        };
        this.selectedTos.push(tag);
        this.form.forward_to_emails.push(newEmail);
      } else {
        this.showFailMsg('Please enter a valid email address');
      }
    },
    addCcCustomMail(newEmail) {
      if (this.validateEmail(newEmail)) {
        const tag = {
          email: newEmail,
        };
        this.selectedCcs.push(tag);
        this.form.cc_emails.push(newEmail);
      } else {
        this.showFailMsg('Please enter a valid email address');
      }
    },
    addBccCustomMail(newEmail) {
      if (this.validateEmail(newEmail)) {
        const tag = {
          email: newEmail,
        };
        this.selectedBccs.push(tag);
        this.form.bcc_emails.push(newEmail);
      } else {
        this.showFailMsg('Please enter a valid email address');
      }
    },
    addNoteCustomMail(newEmail) {
      if (this.validateEmail(newEmail)) {
        const tag = {
          email: newEmail,
        };
        this.selectedUsers.push(tag);
        this.form.notify_emails.push(newEmail);
      } else {
        this.showFailMsg('Please enter a valid email address');
      }
    },
    validateEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped lang="scss">
.multiselect__tags {
  border-radius: 0;
}
.color_green {
  cursor: pointer;
  color: green;
}
.clear_color {
  cursor: pointer;
  color: red;
}
.custom_has_error {
  border: 1px solid red;
}
.product_list_wrap {
  .upload_btn {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    span {
      margin-left: 20px;
    }
  }
  .product_list {
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-left: -5px;
      margin-right: -5px;
      li {
        width: 15%;
        padding-left: 5px;
        padding-right: 5px;
        padding-bottom: 10px;
        .inner {
          .img {
            position: relative;
            overflow: hidden;
            transition: all 0.3s;
            img {
              width: 100%;
            }
            .cross_ic {
              position: absolute;
              top: 20px;
              right: 3px;
              z-index: 2;
              background: red;
              border-radius: 50%;
              width: 20px;
              height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 15px;
              opacity: 0;
            }
            &:hover {
              transition: all 0.3s;
              .cross_ic {
                opacity: 1;
                top: 3px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
